import React from "react";
import CountUp from "react-countup";
import map from "../../images/map/map-fact.png";
import CtaSection from "../CtaSection/CtaSection";
import Mcc from "../mcc/Mcc";

const FunFact = [
  {
    title: "10000",
    subTitle: "гишүүд",
    symbol: "+",
    des: "We help local nonprofits access the funding, tools, training,",
    sclass: "factBlock--one",
  },
  {
    title: "9",
    subTitle: "жил",
    symbol: "+",
    des: "We help local nonprofits access the funding, tools, training,",
    sclass: "factBlock--two",
  },
  {
    title: "10",
    subTitle: "хүмүүнлэгийн ажил",
    symbol: "+",
    des: "We help local nonprofits access the funding, tools, training,",
    sclass: "factBlock--three",
  },
  {
    title: "16000",
    subTitle: "Water",
    symbol: "kg",
    des: "We help local nonprofits access the funding, tools, training,",
    sclass: "factBlock--four",
  },
  {
    title: "25",
    subTitle: "Food",
    symbol: "mln",
    des: "We help local nonprofits access the funding, tools, training,",
    sclass: "factBlock--five",
  },
];

const FunFactSection = (props) => {
  return (
    <section className="fact fact--layout1 position-relative pt-40 pb-40">
      <img src={map} alt="Gainioz" className="fact__map position-absolute" />
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-8 mx-auto">
            <div className="sectionTitle text-center mb-65">
              <Mcc />
              <h2 className="sectionTitle__big">Бидний зарим баримтууд</h2>
            </div>
          </div>
        </div>
        <div className="factWrapper">
          <div className="row gx-50">
            {FunFact.slice(0, 3).map((funfact, fitem) => (
              <div className="col-lg-4" key={fitem}>
                <div className={`factBlock ${funfact.sclass}`}>
                  <h3 className="factBlock__heading">
                    <span className="factBlock__number">
                      <CountUp end={funfact.title} enableScrollSpy />
                    </span>
                    <span className="factBlock__ext">{funfact.symbol}</span>
                  </h3>
                  <span className="factBlock__tag">{funfact.subTitle}</span>
                  {/* <p className="factBlock__text">{funfact.des}</p> */}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <div className="factWrapper factWrapper--two">
          <div className="row justify-content-center gx-50">
            {FunFact.slice(3, 5).map((funfact, fitem) => (
              <div className="col-lg-4" key={fitem}>
                <div className={`factBlock ${funfact.sclass}`}>
                  <h3 className="factBlock__heading">
                    <span className="factBlock__number">
                      <CountUp end={funfact.title} enableScrollSpy />
                    </span>
                    <span className="factBlock__ext">,{funfact.symbol}</span>
                  </h3>
                  <span className="factBlock__tag">{funfact.subTitle}</span>
                  <p className="factBlock__text">{funfact.des}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <CtaSection />
      </div>
    </section>
  );
};

export default FunFactSection;
